import { useEffect, useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import { useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';

export default function FlatDetails() {
  const [flat, setFlat] = useState();
  const { id } = useParams();

  const getFlat = async () => {
    let res = await APIService.get(ANG_APIS.GET_FLAT_DETAILS);
    if (res.status == 200) setFlat(res);
  };

  useEffect(() => {
    getFlat();
  }, []);

  return (
    <div>
      {/* <div ng-if="errormsg"><h3>{{errormsg}}</h3></div> */}
      <form name="myform">
        <label>No of Flat Type:</label>
        <input
          type="number"
          className="field"
          ng-model="model.flat_type_count"
          value={flat?.flat_type_count}
        />
        <h2 className="heading">Add Flat Details</h2>
        <table className="table-data">
          <tr>
            <th>Type of Flat*</th>
            <th>Flat Type Count</th>
            <th>Flat Size/SqFt(Builtup Area)</th>
            <th>Flat Size/SqFt(Carpet Area)</th>
            <th>Rent</th>
            <th>Action</th>
          </tr>
          <tr ng-repeat="flat in flats">
            <td>
              <select type="text" className="field" ng-model="flat.flat_type" required>
                <option ng-repeat="flatType in flat_types">{flat?.flat_type_count}</option>
              </select>
              <span className="error" ng-show="myForm.flat_type.$error.required">
                Error
              </span>
            </td>
            <td>
              <input
                type="number"
                name="flatcount{{$index}}"
                className="field"
                ng-model="flat.flat_count"
                max="1000"
                min="1"
                count
              />
            </td>
            <td>
              <input
                type="number"
                name="area{{$index}}"
                className="field"
                ng-model="flat.size_builtup_area"
                min="1"
                max="{{sizeLimit}}"
                ng-change="getSizeLimit(flat.flat_type)"
              />
            </td>
            <td>
              <input type="number" className="field" ng-model="flat.size_carpet_area" />
            </td>
            <td>
              <input
                type="number"
                name="rent{{$index}}"
                className="field"
                ng-model="flat.flat_rent"
                min="1"
              />
            </td>
            <td>
              <a
                type="button"
                className="glyphicon glyphicon-remove"
                aria-hidden="true"
                ng-click="deleteFlat($index,flat.id)"
              ></a>
            </td>
          </tr>
        </table>
        <input type="button" className="smallBtn" ng-click="addNew()" value="Add" />
        <input
          type="button"
          className="smallBtn"
          ng-click="onSubmit()"
          value="Save Flat Details"
          ng-disabled="myform.$invalid"
        />
      </form>
    </div>
  );
}
